export default "/images/invite_participant_background.webp"